// JsFromRoutes CacheKey 53cb9b415389516199abc83f53407d49
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/broker/clients'),
}
